import React from "react";

import StepBookShuffleOnboarding from "components/Step/StepBookShuffleOnboarding";
import StepLayoutLoadingScreen from "components/Step/StepLayoutLoadingScreen";

import { shouldSkipBookShuffle } from "components/Membership/membershipUtil";
import {
  MembershipState,
  MembershipStep,
} from "components/Membership/membershipTypes";

export const MembershipStepBookShuffle = ({
  routeNextStep,
  ...stepProps
}: MembershipState) => {
  const handleFinish = () => {
    routeNextStep?.();
  };

  const handleBookLoadFailure = async () => routeNextStep?.();

  // skip this step if the input won't produce a valid list of books
  const { childAge, subscription } = stepProps;
  const age = Number(childAge ?? subscription?.childAge);
  if (shouldSkipBookShuffle({ childAge: age })) {
    routeNextStep?.();
    return <StepLayoutLoadingScreen />;
  }

  return (
    <StepBookShuffleOnboarding
      {...stepProps}
      onBookLoadFailure={handleBookLoadFailure}
      onFinish={handleFinish}
      subscriptionId={subscription?.id || undefined}
    />
  );
};

export const MEMBERSHIP_STEP_BOOK_SHUFFLE: MembershipStep = {
  component: MembershipStepBookShuffle,
  id: "membership-id-book-shuffle",
  slug: "book-shuffle",
};

export default MembershipStepBookShuffle;
